import React from 'react';
import loadable from '@loadable/component';
import Loader from 'components/Loader';

const BookingGuests = loadable(() => import(/* webpackChunkName: "BookingGuests" */ './Guests'), {
  fallback: <Loader visible />,
});

export default BookingGuests;
